// ui/web/src/components/buzz/ResizeDragHandle.tsx
import { useRef } from "react"

interface ResizeDragHandleProps {
  onResize: (newWidth: number) => void
  minWidth: number
  maxWidth: number
}

export function ResizeDragHandle({ onResize, minWidth, maxWidth }: ResizeDragHandleProps) {
  const dragging = useRef(false)

  const onMouseDown = (e: React.MouseEvent) => {
    e.preventDefault()
    dragging.current = true
    const startX = e.clientX
    const startWidth = e.currentTarget.parentElement?.offsetWidth ?? 380

    const onMove = (e: MouseEvent) => {
      if (!dragging.current) return
      const newWidth = startWidth - (e.clientX - startX)
      onResize(Math.max(minWidth, Math.min(maxWidth, newWidth)))
    }
    const onUp = () => {
      dragging.current = false
      window.removeEventListener("mousemove", onMove)
      window.removeEventListener("mouseup", onUp)
    }
    window.addEventListener("mousemove", onMove)
    window.addEventListener("mouseup", onUp)
  }

  return (
    <div
      className="absolute left-0 top-0 w-1 h-full cursor-col-resize hover:bg-[var(--color-primary)]/30 transition-colors z-10"
      onMouseDown={onMouseDown}
      role="separator"
      aria-orientation="vertical"
      aria-label="Resize Buzz panel"
    />
  )
}
